import {reqWithToken} from './requestHelper';

export async function getSchoolInfo(){
    return (await reqWithToken('api/SchoolInfo',{
    })).data;
}

